export const FEATURE_TOGGLE = (window as any).AppConfig.FEATURE;

export const ENV = (window as any).AppConfig.ENV;
